import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
// import PinyinInput from "../../../components/ui/PinyinInput";
// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import * as Helper from "../../../../utils/Helper"

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/dictionary/lettersen/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService } from "../../../../navigation";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.lettersen.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_LETTERS_ASYNC]: {
                done: this._handleSaveLettersAsyncDone,
                error: this._handleAsyncActionError
            },
            [ActionTypes.BATCH_ADD_LETTERS_ASYNC]: {
                done: this._handleSaveLettersAsyncDone,
                error: this._handleAsyncActionError
            }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createLetters();
    }

    render() {
        const { letter } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!letter || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) || this.isActionExecuting(ActionTypes.SAVE_LETTERS_ASYNC) || this.isActionExecuting(ActionTypes.BATCH_ADD_LETTERS_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    navParams={this.localVars.navParams}
                                    letter={letter}
                                    onSave={this._handleSaveLetters}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveLetters = (data) => {
        const { id } = this.localVars.navParams;
        if (!id) {
            this.props.batchAddLettersAsync(data);
            return;
        }
        this.props.saveLettersAsync(data);
    };

    _handleSaveLettersAsyncDone = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.dictionary.lettersen.list, this.localVars.navParams);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };
}

function EditForm(props) {
    const formMethods = useForm();
    const { letter } = props;
    const { id, pron } = letter;
    const { register, handleSubmit, errors, clearError } = formMethods;
    const submitRef = useRef();

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("letter")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            tag={Link}
                            to={{ pathname: NavigationService.getPathNameByUID(UIDs.screens.admin.dictionary.lettersen.list), state: props.navParams }}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("id")}</label>
                                    <textarea rows="3" disabled={!!id} name="id" type="text"
                                        className="form-control-alternative form-control" defaultValue={id}
                                        ref={register({ required: true })} />
                                    {errors.id && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                    {/* <PinyinInput inputClassName={"form-control-alternative form-control"}/> */}
                                </div>
                            </div>
                        </div>
                        <div className="row" hidden={!id}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("pron")}</label>
                                    <input name="pron" className="form-control-alternative form-control"
                                        defaultValue={pron}
                                        ref={register} />
                                    {errors.pron && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: letter => dispatch(Actions.loadScreenViewAsync(letter)),
        saveLettersAsync: vo => dispatch(Actions.saveLettersAsync(vo)),
        createLetters: () => dispatch(Actions.createLetters()),
        batchAddLettersAsync: vo => dispatch(Actions.batchAddLettersAsync(vo))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
